import React, { useEffect, useState } from 'react';
import StaffLayout from '../../layouts/StaffLayout';
import { Box, Typography, Grid, Paper, CircularProgress, Tooltip } from '@mui/material';
import api from '../../services/api';

function StaffBoothPage() {
  const [booths, setBooths] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    api.get('/api/booths')
      .then(res => setBooths(Array.isArray(res.data) ? res.data : []))
      .catch(err => setError(err.response?.data?.error || 'Failed to fetch booths'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <StaffLayout>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Booth Management
        </Typography>
        <Paper sx={{ p: 3, borderRadius: 3, mb: 3 }}>
          <Typography variant="body2" color="text.secondary" mb={2}>
            All booths assigned to staff are listed below.
          </Typography>
          {error && <Typography color="error" mb={2}>{error}</Typography>}
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              {booths.length === 0 && (
                <Grid item xs={12}><Typography>No booths found.</Typography></Grid>
              )}
              {booths.map((b) => (
                <Grid item xs={12} sm={6} md={4} key={b._id}>
                  <Paper sx={theme => ({
                    p: 2.2,
                    borderRadius: 3,
                    boxShadow: 3,
                    mb: 2,
                    background: theme.palette.mode === 'dark' ? '#23243a' : '#fcfcff',
                    border: `1.5px solid ${theme.palette.divider}`,
                    color: theme.palette.mode === 'dark' ? '#fff' : 'inherit',
                  })}>
                    <Typography variant="subtitle1" fontWeight={700} color={theme => theme.palette.mode === 'dark' ? 'secondary.light' : 'primary.main'} sx={{ fontSize: 16.5 }}>
                      {b.name || b.title || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color={theme => theme.palette.mode === 'dark' ? 'grey.200' : 'text.secondary'} gutterBottom sx={{ fontSize: 13.5, mt: 0.2 }}>
                      <b>Location:</b> {b.location || 'N/A'}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 0.2, fontSize: 13.2, color: theme => theme.palette.mode === 'dark' ? 'grey.100' : 'inherit' }}>
                      <b>Company:</b> {b.company || 'N/A'}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
        </Paper>
      </Box>
    </StaffLayout>
  );
}

export default StaffBoothPage;
